import { render } from "./TemplateContainer.vue?vue&type=template&id=eca9ddd4&scoped=true"
import script from "./TemplateContainer.vue?vue&type=script&lang=js"
export * from "./TemplateContainer.vue?vue&type=script&lang=js"

import "./TemplateContainer.vue?vue&type=style&index=0&id=eca9ddd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca9ddd4"]])

export default __exports__